import React, { cloneElement, useRef } from "react";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { Button } from "@mui/material";

const PaymentRequest = ({
  children,
  generateEncryption,
  handleClose,
  t,
  isPowerUtility,
}) => {
  const encRef = useRef();
  const formRef = useRef();
  const accessCodeRef = useRef();

  const handleClick = async () => {
    try {
      const myForm = formRef.current;
      const encRequestElement = encRef.current;
      const accessCodeElement = accessCodeRef.current;

      const { data: { encryptedUrl } = {} } = await generateEncryption();

      if (encryptedUrl) {
        encRequestElement.value = encryptedUrl;
        accessCodeElement.value = isPowerUtility
          ? process.env.REACT_APP_CCAVENUE_ACCESS_CODE_FOR_POWER_UTILITY
          : process.env.REACT_APP_CCAVENUE_ACCESS_CODE_FOR_OTHER_UTILITY;
        myForm.submit();
      } else {
        toast.success("Bill paid successfully");
        handleClose();
      }
    } catch (error) {}
  };

  return (
    <form
      ref={formRef}
      method="post"
      action={process.env.REACT_APP_CCAVENUE_PAYMENT_URL}
    >
      <input type="hidden" name="encRequest" ref={encRef} />
      <input type="hidden" name="access_code" ref={accessCodeRef} />

      {children ? (
        cloneElement(children, {
          onClick: handleClick,
        })
      ) : (
        <div style={{ paddingRight: "20px" }}>
          <Button onClick={handleClick} variant="outlined">
            {t("Pay Now")}
          </Button>
        </div>
      )}
    </form>
  );
};

export default withTranslation()(PaymentRequest);

PaymentRequest.propTypes = {
  children: PropTypes.element,
  generateEncryption: PropTypes.func,
  handleClose: PropTypes.func,
  isPowerUtility: PropTypes.bool,
  t: PropTypes.func,
};
